import {useDebounce} from "use-debounce";
import {useEffect, useState} from "react";

export const useDebouncedSearch = ({
  onDebounce,
  onSetQuery,
  onEmptyQuery,
}: {
  onDebounce: (term: string) => void;
  onSetQuery?: () => void;
  onEmptyQuery: () => void;
}) => {
  const [query, setQuery] = useState<string>("");
  const [searched, setSearched] = useState<boolean>(false);
  const [debouncedSearchTerm] = useDebounce(query, 500);
  useEffect(() => {
    if (debouncedSearchTerm) onDebounce(debouncedSearchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (!searched) return;
    if (!query) onEmptyQuery();
    if (onSetQuery) onSetQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, searched]);

  useEffect(() => {
    if (!searched && query) setSearched(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return {setQuery, query};
};
